import React from "react";
import StayTouch from "../../layout/StayTouch";
import AuthBanner from "../../reusable/AuthBanner";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import PricingContent from "./PricingContent";
class Pricing extends React.Component {
  render() {
    return (
      <div>
        <AuthBanner title="Pricing" className="pricing" />
        <PricingContent />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(Pricing);



// WEBPACK FOOTER //
// ./src/pages/pricing/index.js